// Dependencias generales
import React from "react";
import { useEffect } from 'react';

function actualizarBreadCrumb(currentStep) {    

  if(currentStep.step==="NEW"){
    document.getElementById("ulBreadCrumb").className += " hidden"
  }
  else if(currentStep.step==="WELCOME"){document.getElementById("WelcomeBC").className="current"}
  else if(currentStep.step==="GENERAL_INFO"){document.getElementById("GeneralInfoBC").className="current"}
  else if(currentStep.step==="MESSAGING"){document.getElementById("MessagingBC").className="current"}  

  document.getElementById("liGeneralInfoBC").style= "display"

}

// Función del router
const InitialConfigHeader = (currentStep) => {

  useEffect(() => {    
    actualizarBreadCrumb(currentStep);   
    if(localStorage.getItem("installationConfigurationMode") !== null){
      document.getElementById("liWelcomeBC").style="display: none"      
      document.getElementById("linkSalir").style="display: none"   
      document.getElementById("initialConfigBreadcrumb").style="display: none"               
    }
  });
  
  return (
    <header id="initialConfigBreadcrumb" className="wrapper">
        <nav className="pager">
            <ul id="ulBreadCrumb">
                <li id="liWelcomeBC" ><a id="WelcomeBC" href="/InstallerInitialConfig/Welcome"><span className="hidden">Bienvenid@</span></a></li>
                <li id="liGeneralInfoBC" ><a id="GeneralInfoBC" href="/InstallerInitialConfig/GeneralInfo"><span className="hidden">Información general</span></a></li>                
                <li id="liMessagingBC"><a id="MessagingBC" href="/InstallerInitialConfig/Messaging"><span className="hidden">Mensajería</span></a></li>                
            </ul>
        </nav>
        <a id="linkSalir" className="link" href="/Logout" >Salir</a>
    </header>           
  )
}

export default InitialConfigHeader